<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <div class="row">
      <div class="col-md-6 col-sm-9 col-xs-12">
        <div class="card-body">
          <div v-if="assessment.confidential && !checkPermission(['F_ASSESSMENT'])">
            <div class="alert alert-info">THIS ASSESSMENT IS CONFIDENTIAL</div>
          </div>
          <div v-else class="row">
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div class="form-group">
                <label for="curriculum">Selection Process</label>   
                <div class="input-group"> 
                  <b-form-select v-model="assessment.selectionProcessId" :options="selectionProcessList" value-field="id" text-field="value"></b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div class="form-group">
                <label for="status">Status <span class="text-danger">*</span></label>   
                <div class="input-group"> 
                  <b-form-select v-model="assessment.assessmentStatusId" :state="$v.assessment.assessmentStatusId.$dirty ? !$v.assessment.assessmentStatusId.$error : null" :options="assessmentStatusList" value-field="id" text-field="description"></b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="status">Description </label>   
                <div class="input-group"> 
                  <b-form-textarea id="textarea-default" v-model="assessment.description" rows="8"></b-form-textarea>
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div v-if="checkPermission(['F_ASSESSMENT'])" class="form-group">
                <label for="status">Confidential </label>   
                <div class="input-group"> 
                  <b-form-checkbox v-model="assessment.confidential" switch size="lg" :value="true"></b-form-checkbox>
                </div>
              </div>
            </b-col>
            <b-col class="mt-3" cols="12" sm="12" md="12" lg="12" xl="12">
              <b-button variant="success" @click="updateAssessment">Save</b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      curriculumId: this.id,
      selectionProcessList: [],
      assessmentStatusList: [],
      assessment: {},
      isLoading: false,
      fullPage: false,
      zIndex: 9999
    }
  },
  validations: {
    assessment: {
      assessmentStatusId: { required }
    }
  },
  created () {
    this.loadStatus()
  },
  methods: {
    ...authMethods,
    checkPermission(roles) {
      return roles.some((r) => this.user.userRoles.includes(r))
    },
    loadStatus () {
      this.isLoading = true
      axios.get(`${appConfig.apiUrl}assessment/status`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.assessmentStatusList = response.data
      })
      .finally(() => {
        this.loadSelectionProcess()
      })
    },
    loadSelectionProcess () {
      axios.get(`${appConfig.apiUrl}selection-process/combo`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.selectionProcessList = response.data
      })
      .finally(() => {
        this.loadAssessment()
      })
    },
    loadAssessment () {
      axios.get(`${appConfig.apiUrl}assessment/curriculum/${this.curriculumId}`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        if (response.data) {
          this.assessment = response.data
        } else {
          this.assessment = {}
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    updateAssessment() {
      this.$v.assessment.$touch()
      if (this.$v.assessment.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      this.assessment.curriculumId = this.curriculumId

      this.isLoading = true
      axios.post(appConfig.apiUrl + 'assessment/save',
        qs.stringify(this.assessment),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Sucess', text: 'Saved Sucessful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadAssessment()
        })
    }
  }
}
</script>

<style>

</style>
